import { render, staticRenderFns } from "./DisclosureTransport.vue?vue&type=template&id=2af6fc90&scoped=true&"
import script from "./DisclosureTransport.vue?vue&type=script&lang=ts&"
export * from "./DisclosureTransport.vue?vue&type=script&lang=ts&"
import style0 from "./DisclosureTransport.vue?vue&type=style&index=0&id=2af6fc90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af6fc90",
  null
  
)

export default component.exports